<template>
<ValidationObserver ref="appetite">
  <b-card border-variant="primary" body-class="px-7 py-5" class="mb-10" v-if="brand">
    <div v-if="brand.toUpperCase() === 'RENTSURE' || brand.toUpperCase() === 'CRI'" class="font-weight-bold font-size-lg">
      Our policy covers the following vehicles:
      <div class="mt-2">
        <ul class="ml-10 mb-2">
          <li>Passenger vehicles</li>
          <li>SUVs</li>
          <li>4WDs</li>
          <li>Light and heavy commercial vehicles</li>
        </ul>
        We accommodate up to 10% plant and equipment.
      </div>

      <div class="mt-5">
        The following vehicles are not in our appetite for cover:
        <ul class="ml-10">
          <li>Caravans and motor homes</li>
          <li>Motorcycles</li>
          <li>Exotic and high-end prestige vehicles</li>
          <li>Modified, muscle, vintage, collectible or custom vehicles</li>
          <li>Chauffeur vehicles</li>
          <li>Couriers</li>
          <li>Taxis (Rideshare is covered)</li>
          <li>Uber Eats</li>
          <li>Peer-to-peer</li>
        </ul>
      </div>

      <div class="mt-5">
        Our coverage segments include:
        <ul class="ml-10">
          <li>Self-drive traditional (Min fleet 10+)</li>
          <li>Car Share (Min fleet 10+)</li>
          <li>Car Leasing (Min Fleet 10+)</li>
          <li>Subscription (Min Fleet 10+)</li>
          <li>Rideshare (Min fleet 50+)*</li>
          <li>Accident Replacement (Min fleet 20+, 50+ in Victoria)**</li>
        </ul>
        * Rideshare: Fleets of 20+ considered on a case-by-case basis. Minimum 3 years of business operation,
          documented claims history and commitment to telematics partnership required.<br/>
        ** Accident replacement: Minimum 3 years of business operation with documented claims history.
      </div>

    </div>

    <div v-if="brand.toUpperCase() === 'FUSE'" class="font-weight-bold font-size-lg">
      Our policy covers the following vehicles:
      <div class="ml-10 mt-2">
        <ul>
          <li>Passenger vehicles</li>
          <li>Commercial vehicles</li>
          <li>Plant & machinery (up to 50% of combined market value of the fleet)</li>
        </ul>
      </div>
      The following vehicles are not in our appetite for cover:
      <div class="ml-10 mt-2">
        <ul>
          <li>Exotic vehicles</li>
          <li>Caravans and motorhomes</li>
          <li>High-end prestige</li>
          <li>Modified, muscle, collectible, custom vehicles, or vintage</li>
          <li>Courier</li>
          <li>Taxi</li>
          <li>Off-road vehicles</li>
          <li>Motorcycles</li>
          <li>Agricultural</li>
        </ul>
      </div>
      Please note, our minimum fleet requirement is 15 vehicles.<br/>
    </div>
  </b-card>

</ValidationObserver>
</template>

<style lang="scss">
</style>

<script>

export default {
  name: "Appetite",

  props: {
    brand: String
  }
};
</script>
